// Browser-side twin of back/utils/artifactPrefix.js.
//
// Every identifier a project generates carries its own prefix
// (Project.artifactPrefix, default "BLT") instead of the old hardcoded
// "MK". The prefix is denormalised onto each issue, so a label can be
// rendered from the issue alone - no project lookup in the component.
export const DEFAULT_PREFIX = "BLT";

export function normalizePrefix(value) {
  const s = String(value === undefined || value === null ? "" : value)
    .toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
  return s || DEFAULT_PREFIX;
}

export function prefixOf(project) {
  if (!project) return DEFAULT_PREFIX;
  if (typeof project === "string") return normalizePrefix(project);
  return normalizePrefix(project.artifactPrefix);
}

// "SPX-126" - falls back to the id suffix when no display id was minted.
export function issueLabel(issue, fallbackPrefix) {
  if (!issue) return "";
  const prefix = normalizePrefix(issue.artifactPrefix || fallbackPrefix);
  if (issue.displayId === null || issue.displayId === undefined || issue.displayId === "") {
    return issue._id ? `${prefix}-${String(issue._id).slice(-3).toUpperCase()}` : prefix;
  }
  return `${prefix}-${issue.displayId}`;
}

// Empty string (not "SPX-") when the issue has no display id.
export function issueLabelOrEmpty(issue, fallbackPrefix) {
  if (!issue || issue.displayId === null || issue.displayId === undefined || issue.displayId === "") return "";
  return issueLabel(issue, fallbackPrefix);
}

// Label from a bare display id plus a prefix (table cells that only have
// the number in hand).
export function labelFor(displayId, prefix) {
  if (displayId === null || displayId === undefined || displayId === "") return "";
  return `${normalizePrefix(prefix)}-${displayId}`;
}
